import useTranslation from 'next-translate/useTranslation'

import ClaimLockedMETRewardsForm from '../components/ClaimLockedMETRewardsForm'
import UnlockForm, { UnlockFormProps } from '../components/UnlockForm'

import useOperationsDrawer from './useOperationsDrawer'

const useLockMETOperationsDrawer = function () {
  const { t } = useTranslation()
  return useOperationsDrawer<UnlockFormProps>({
    claim: {
      component: ClaimLockedMETRewardsForm,
      title: t('actions.claim')
    },
    unlock: {
      component: UnlockForm,
      title: t('actions.unlock')
    }
  })
}

export default useLockMETOperationsDrawer
